import { useEffect } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import AddAllergyComponent from './component';
import { useAllergy } from './hooks';
import { allergySchema } from './schema';
import { AddAllergyProps, TAllergyInitialValues } from './types';
import { ALLERGY_FORM_FIELD_DATA } from '../../../constants/allergy';

const AddAllergy: React.FC<AddAllergyProps> = ({
  isModalOpen,
  setIsModalOpen,
}) => {
  const initialValues: TAllergyInitialValues = {
    id: null,
    name: '',
    severity: '',
    durationType: '',
    durationValue: null,
  };

  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const { updatePatientAllergy, isSuccess } = useAllergy(currentUser?.id);

  const handleSave = (values: TAllergyInitialValues) => {
    const effectiveDurationType = values.durationValue
      ? values.durationType || 'Days'
      : '';
    updatePatientAllergy({
      id: values.id || undefined,
      name: values.name,
      level: values.severity,
      durationType: effectiveDurationType,
      durationValue: values.durationValue,
      hospitalId: currentUser?.hospitalId,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setIsModalOpen(false);
    }
  }, [isSuccess, setIsModalOpen]);

  return (
    <AddAllergyComponent
      initialValues={initialValues}
      formFieldData={ALLERGY_FORM_FIELD_DATA}
      isModalOpen={isModalOpen}
      validationSchema={allergySchema}
      setIsModalOpen={setIsModalOpen}
      onSave={handleSave}
    />
  );
};

export default AddAllergy;
